// extracted by mini-css-extract-plugin
export var collapsedSummary = "_ro-0";